import styled from 'styled-components';

import { getPurpurColor, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const PriceTagElement = styled.span`
    font-size: ${getPurpurTypography('scale200')};
    font-weight: ${getPurpurTypography('weightBold')};
    color: ${getPurpurColor('brandCorePurple')};
`;

export const OldPriceTagElement = styled.span`
    font-size: ${getPurpurTypography('scale75')};
    font-weight: ${getPurpurTypography('weightNormal')};
    text-decoration: line-through;
    color: ${getPurpurColor('textDefault')};
`;
